import React, { FC, lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import { ACTIONS, WORKSPACES } from 'constants.js';

const CreateLoanTransaction = lazy(
  () => import(/* webpackChunkName: 'Wire' */ 'components/corporateLoans/Loans')
);

const ViewLoanPayment = lazy(
  () =>
    import(/* webpackChunkName: 'ViewLoanPayment' */ 'components/ViewPaymentDir/loan/ViewPayment')
);

const LoanPaymentTemplateWorkflow = lazy(
  () =>
    import(
      /* webpackChunkName: 'LoanPaymentTemplateWorkflow' */ 'components/loanPaymentTemplate/Workflow'
    )
);

const { CREATE, INITIATE, MODIFY, VIEW } = ACTIONS;
const LOAN_PATH = `${WORKSPACES.PYMTCNTR}/loans`;

const LoanRoutes: FC = () => (
  <Switch>
    <Route
      path={`${LOAN_PATH}/template/create/:paymentType`}
      render={() => <LoanPaymentTemplateWorkflow action={CREATE} />}
      exact
    />
    <Route
      path={`${LOAN_PATH}/template/view/:id`}
      render={() => <LoanPaymentTemplateWorkflow action={VIEW} />}
      exact
    />
    <Route
      path={`${LOAN_PATH}/template/modify/:id`}
      render={() => <LoanPaymentTemplateWorkflow action={MODIFY} />}
      exact
    />
    <Route
      path={`${LOAN_PATH}/create/:paymentType`}
      component={({ match: { params: { paymentType = 'payments' } = {} } = {} }) => (
        <CreateLoanTransaction paymentType={paymentType} action={INITIATE} />
      )}
      exact
    />
    <Route
      path={`${LOAN_PATH}/template/initiate/:id`}
      component={({ match: { params: { id = '' } = {} } = {} }) => (
        <CreateLoanTransaction templateId={id} action={INITIATE} />
      )}
      exact
    />
    <Route
      path={`${LOAN_PATH}/view/:id`}
      render={({ match: { params: { id = '' } = {} } = {} }) => <ViewLoanPayment id={id} />}
      exact
    />
  </Switch>
);

export default LoanRoutes;
